import React from 'react';
import { Field, reduxForm } from 'redux-form';
import ModalBox from '../../../../shared/modal';
import InputField from '../../../../shared/form-elements/input';
import DatePicker from '../../../../shared/form-elements/date-picker/main';

const ProlongRequest = props =>
	<ModalBox
		title={props.intl(
			'Изменение периода действия по сиду № '
			+ props.changeDatePopupRequestId
			+ (props.changeDatePopupRequestSid ? ` Sid: ${props.changeDatePopupRequestSid} ` : '')
		)}
		body={PopupContent(props)}
		isOpen={props.isOpen}
		onClose={props.togglePopup}
	/>;

const PopupContent = props => {
	const submit = props.changeDate.bind(null, props.changeDatePopupRequestId, props.changeDatePopupRequestSid);
	return (
		<div className="adv-request__wrap">
			<form onSubmit={props.handleSubmit(submit)} >
				<Field
					className="offers-form__field__date-picker"
					name='ends_at'
					component={DatePicker}
				/>
				<Field
					name="comment"
					searchable={false}
					component={InputField}
					placeholder="Comment"
				/>
				<button
					className="ui-btn ui-btn-primary save margin-top-120"
				>
					{props.intl('Submit')}
				</button>
			</form>
		</div>
	);
};

export default reduxForm({
	form: 'garantRegisterChangeEndDate'
})(ProlongRequest);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/guarant-approve-register/list/components/forms/change-end-date.js